import React from 'react'
import '../Blog.css'
import copy from "copy-to-clipboard";
import { useState } from 'react';
import axios from 'axios';
// import SyntaxHighlighter from 'react-syntax-highlighter';
// import { solarizedDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
export default function CodeDiv(props) {
    const [code, setCode] = useState('');
    let fetchData = async (url) => {
        await axios.get(url).then(response => {
            setCode(response.data);
        }).catch(error => {

        })
    }
    return (
        < >
            <div className={`code ${props.headerStyle}`}>
                < div className="header" >
                    <div onClick={() => {
                        copy(code);
                    }} className="copy">
                        copy
                    </div>
                </div>
                <div className="codeDiv">
                    <pre className="blogContent">
                        {/* <SyntaxHighlighter
                            language={props.language}
                            style={solarizedDark}
                            customStyle={{
                                background: "transparent",
                                opacity: "1",
                                color: 'white',
                            }}
                        >
                            {props.code}
                        </SyntaxHighlighter> */}
                        <code >
                            {props.code}
                        </code>
                        <code  {...fetchData(props.url)} >
                            {code}
                        </code>
                    </pre>
                </div>
            </div>
        </>
    )
}
